class InvoicedOrderController extends AbstractController
	@register()
	@inject '$state',
		'$q'
		'$stateParams'
		'OrderRepository'
		'InvoicedOrderRepository'
		'SEARCH_CONFIGURATION'
		'invoicedTransactionStatusEnum': 'BACKEND_INVOICED_TRANSACTION_STATUS'
		'BACKEND_TRANSACTION_STATE'
		'BACKEND_TRANSACTION_PAYMENT_TYPE'

	initialize: ->
		@orders = []

		@filterDTO = new FilterDTO({
			searchConfiguration: @SEARCH_CONFIGURATION.invoiced_order,
			sortProperty: 'timestamp'
			itemsCount: 0
		})

		if @$stateParams.invoice_id
			@filterDTO.setFilterValue 'invoice_id', @$stateParams.invoice_id

		@invoicedOrderStatuses = []
		i = 0

		for key, status of @invoicedTransactionStatusEnum
			@invoicedOrderStatuses.push({
				id: status,
				index: i++,
				name: @translate('general.order.invoice.status.' + status)
			})

	getAdvancedSearchValues: (filterKey) ->
		if filterKey == 'status'
			return @$q.when(@invoicedOrderStatuses)

	onBeforeAdvancedSearch: (query, term, filterKey) ->
		if filterKey == 'customer_id'
			query.criteria 'allow_credit', '=', '1'

	search: ->
		@searching = true

		query = @filterDTO.getQuery()

		query.with 'customer',
			'transactions'
			'transactions>invoice'
			'order_line_items'
			'order_line_items>addon_line_items'
			'order_line_items>bundled_line_items'

		query.criteria 'is_paid', '=', '1'
		query.criteria 'transactions>type', '=', @BACKEND_TRANSACTION_PAYMENT_TYPE.INVOICE

		@InvoicedOrderRepository
			.getEntities query
			.then (response) =>
				@orders = @OrderRepository.calculateOrderSum response

				for order in @orders
					for transaction in order.transactions or []
						if transaction.state == @BACKEND_TRANSACTION_STATE.CAPTURED && transaction.type == @BACKEND_TRANSACTION_PAYMENT_TYPE.INVOICE
							order.invoice_id = transaction.invoice_id

							break

				@filterDTO.itemsCount = @orders.length

				@searching = false
